$(->
    $(document).on 'click', '#super_account_table a.lazy-submit', ->
      el = $(this)
      if el.data('field')?
        $(el.data('field')).val(el.data('value'))
      el.closest('form').submit()
)
